<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn search-picker">
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.SId" class="search-item" size="small" filterable clearable remote @visible-change="getWarehouse()">
                        <el-option v-for="optionItem in warehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option
                        >
                    </el-select>
                    <div class="search-name">客户</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.EntpCusName"
                        remote
                        filterable
                        allow-create
                        placeholder="客户名称/电话"
                        :remote-method="searchCustom"
                        v-select-scroll-more="searchCustomLoad"
                        popper-class="my-select"
                    >
                        <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                            <div class="name">
                                {{ item.EntpCusName }}
                                <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div class="search-name">退货单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.ReturnCode"
                        v-filter-special-char="searchData.ReturnCode"
                        placeholder="请输入退货单号"
                    ></el-input>
                    <div class="search-name">销售单号</div>
                    <el-input
                        class="search-item"
                        size="small"
                        v-model.trim="searchData.OrderCode"
                        v-filter-special-char="searchData.OrderCode"
                        placeholder="请输入销售单号"
                    ></el-input>
                    <div class="search-name">物流状态</div>
                    <el-select class="search-item" size="small" v-model="searchData.State">
                        <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">创建时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <!-- <el-button v-if="permission.scanSaleReturnIn" title="扫码入仓" size="small" class="search-btn" type="warning" @click="scanSaleReturnIn()">{{
                                permission.scanSaleReturnIn
                            }}</el-button>                     -->
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :tableCode="tableCode"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    border
                    @selection-change="handleSelectionChange"
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; cursor: pointer"
                    highlight-current-row
                    @cell-dblclick="handleDBClick"
                    :row-key="getRowKeys"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column type="selection" reserve-selection width="55px"></el-table-column>
                    <template v-for="(col,index) in columnShowSets">
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'OrderCode'"
                            show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <el-button @click="gotoSalesDetails(scope.row)" type="text">{{ scope.row.OrderCode }}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :label="col.ColumnName"
                            resizable
                            :sortable="col.IsSort?'custom':false"
                            header-align
                            :prop="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </el-table-column>
                    </template>
                    <el-table-column label="操作" fixed="right" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    v-if="permission.printGoodsLabels && !scope.row.IsIn "
                                    title="打印商品标签"
                                    size="mini"
                                    type="text"
                                    @click="showPrintLabelsDialog(scope.row)"
                                    >{{ permission.printGoodsLabels }}</el-button
                                >   
                                <el-button v-if="permission.saleReturnIn && !scope.row.IsIn" @click="gotoDetails(6, scope.row)" type="text" size="small">{{
                                    permission.saleReturnIn
                                }}</el-button>
                                <el-button v-if="permission.checkLabels" title="查看标签" size="mini" style="color: orange" type="text" @click="showLabelDetails(scope.row)">查看标签</el-button>
                                <!-- <el-button v-if="permission.scanSaleReturnIn && !scope.row.IsIn" @click="scanIn(scope.row)" type="text" size="small">{{
                                    permission.scanSaleReturnIn
                                }}</el-button> -->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="saleReturn"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印销售退货商品标签" :visible.sync="printLabelDialog" width="1200px">
                <div class="dialog-content" v-if="printLabelDialog">
                    <printGoodsLabels @closeDialog="printLabelDialog" :EntpOId="entpSROId"></printGoodsLabels>
                </div>
            </el-dialog>         
            <el-dialog :close-on-click-modal="false" title="查看标签" :visible.sync="showLabelsDialog" width="1200px" append-to-body>
                <div class="dialog-content" v-if="showLabelsDialog">
                    <checkOrderLabels @closeDialog="closeLabelsDialog" :OrderId="orderId"></checkOrderLabels>
                </div>
            </el-dialog>   
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import printGoodsLabels from '@/components/business/goods/printSROGoodsLabels.vue';
import checkOrderLabels from '@/components/business/salesManage/checkSROrderLabels.vue';
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        statistics,
        breadcrumb,
        elTableColumn,
        printGoodsLabels,
        checkOrderLabels
    },
    props: ['type'],
    data() {
        return {
            tableCode: 'SROrderInTable',
            dateTimes: [],
            statisticsVisible: false,
            orderId:'',
            showLabelsDialog: false,
            multipleSelection: null,
            tableData: [],
            options: [],
            warehouseList: [],
            searchData: {
                State: '5',
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未入仓', Value: '5' },
                { Text: '部分入仓', Value: '10' },
                { Text: '已入仓', Value: '15' }
            ],
            tableDataLength: 0,
            permission: {},
            dialogFormVisible: false,
            RefuseReasonForm: { rid: '', reason: '', index: 0 },
            rules: {
                reason: [
                    { required: true, message: '请输入原因', trigger: 'blur' },
                    { max: 100, message: '原因长度超长', trigger: 'blur' }
                ]
            },
            reasonDialogVisible: false,
            formloading: false,
            reasonFormData: {},
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            columnShowSets: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            entpSROId:"",//退货单id
            printLabelDialog:false,//显示打印商品标签弹窗
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        } else {
            this.doLayout('multipleTable');
        }
    },
    created() {
        if (this.tableCode) this.getSetsData();
    },
    mounted() {
        // let history_searchParams = this.$util.getLocalStorage("searchParams");
        // if (history_searchParams) {
        //   //判断查询参数是否有记录
        //   this.searchData = history_searchParams;
        //   this.$util.clearLocalStorage("searchParams"); //用完即删
        // }
        this.getTableData();
        this.searchCustom();
        this.permission = this.$util.getPermission('salesReturnsTakeIn');
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },

    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.SReturnId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 跳转到关联销售单
        gotoSalesDetails(row) {
            // let searchParams = this.searchData;
            // Vue.set(searchParams, "dataIndex", "saleReturnIn");
            // this.$util.setLocalStorage("searchParams", searchParams); //保存当前查询参数，返回页面时使用
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=1&id=${row.EntpCusOId}&fromLv2=boundin`);
        },
        resetSearch() {
            this.searchData = {
                State: '',
                EntpCusName: '',
                ReturnCode: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                SId: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.dateTimes = [];
            // this.searchCustom('');
            this.$refs.multipleTable.clearSelection();
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            // let searchParams = this.searchData;
            // Vue.set(searchParams, "dataIndex", "saleReturnIn");
            // this.$util.setLocalStorage("searchParams", searchParams); //保存当前查询参数，返回页面时使用
            let SReturnId = item ? item.SReturnId : '';
            let EntpCusOId = item ? item.EntpCusOId : '';
            this.$router.push(`/inventoryManage/salesReturns/takeIn/edit?type=${type}&SReturnId=${SReturnId}&id=${EntpCusOId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetEntpCusSaleReturnInList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                this.gotoDetails(1, event);
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        getWarehouse() {
            if (this.warehouseList.length == 0) {
                this.$util.getWarehouse().then(data => {
                    this.warehouseList = data;
                });
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (column.property == 'SName' || column.property == 'Creator' || column.property == 'OrderCode') {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        scanSaleReturnIn(){
            this.$router.push(`/inventoryManage/salesReturns/scanIn`);
        }, 
        scanIn(item) {
            if (item.SReturnId) this.$router.push(`/inventoryManage/salesReturns/scanIn?oid=${item.SReturnId}`);
            else {
                this.$util.warningMsg('请选择要入仓的退货单');
            }
        },        
        //关闭订单弹出层
        closePrintLabelsDialog() {
            this.entpSROId = '';
            this.printLabelDialog = false;
        },
        // 打印
        showPrintLabelsDialog(row) {
            if (row) {
                this.entpSROId = row.SReturnId;
                this.printLabelDialog = true;
            } else {
                this.$util.warningMsg('请选择入仓单进行打印');
                return;
            }
        },       
        //关闭订单弹出层
        closeLabelsDialog() {
            this.orderId = '';
            this.showLabelsDialog = false;
        },
        // 打印
        showLabelDetails(row) {
            if (row) {
                this.orderId = row.SReturnId;
                this.showLabelsDialog = true;
            } else {
                this.$util.warningMsg('请选择单据进行查看');
                return;
            }
        },        
    }
};
</script>